import { FieldMask } from 'google-protobuf/google/protobuf/field_mask_pb';
import transcript_pb from '@gen/proto/lr/transcript/v1alpha1/transcript_pb';
import transcript_pb_grpc, { ServiceError } from '@gen/proto/lr/transcript/v1alpha1/transcript_pb_service';
import { grpc } from '@improbable-eng/grpc-web';

import { CAPTION_RTMP_API_URL, TRANSCRIPT_SERVICE_HOST } from '../../config';

export const createClient = () =>
  new transcript_pb_grpc.TranscriptServiceClient(TRANSCRIPT_SERVICE_HOST, {
    transport: grpc.FetchReadableStreamTransport({}),
  });

/** Add or remove user from a group in keycloak.
 * @param userId keycloak user id
 * @param currentGroups list of groups the user currently wants to be in
 */
export const updateGroupMembership = (userId: string, currentGroups: string[], accessToken: string) => {
  const client = createClient();

  const updateMask: FieldMask = new FieldMask();
  updateMask.setPathsList(['groups']);

  const user = new transcript_pb.User();
  user.setUserId(userId);
  user.setGroupsList(currentGroups);

  const req = new transcript_pb.UpdateUserRequest();
  req.setUser(user);
  req.setUpdateMask(updateMask);

  client.updateUser(
    req,
    new grpc.Metadata(
      accessToken
        ? {
            Authorization: `Bearer ${accessToken}`,
          }
        : {},
    ),
    (error: ServiceError | null) => error && console.error(error),
  );
};

export const setKappiOwner = async (userId: string, name: string, email: string, accessToken: string) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify({
      user_id: userId,
      name: name,
      email: email,
    }),
  };

  const newOwnerResp = await fetch(`${CAPTION_RTMP_API_URL}/owners`, requestOptions);
  const isJson = newOwnerResp.headers.get('content-type')?.includes('application/json');
  const respData = isJson && (await newOwnerResp.json());
  if (!newOwnerResp.ok) {
    const alreadyExistsRet = { success: true, message: 'Notandi var þegar Owner á Kappa.' };
    if (respData.message) {
      if (respData.message.includes('UNIQUE_RESTRAINT_VIOLATION')) {
        return alreadyExistsRet;
      }
      return { success: false, message: respData.message };
    } else if (respData.error.message) {
      if (respData.error.message.includes('UNIQUE_RESTRAINT_VIOLATION')) {
        return alreadyExistsRet;
      }
      return { success: false, message: respData.error.message };
    } else {
      return { success: false, message: (respData && respData.message) || newOwnerResp.status };
    }
  }
  return { success: true };
};
